import { VendedorHierarquiaStruct } from '../services/structs/pessoa/vendedor-hierarquia.struct';

// Espelho em TS de VendedorHierarquiaHelper (backend) — mesma regra de ciclo/exclusividade,
// operando sobre a lista plana cacheada no cadastro, para validar o formulário em tempo real,
// sem round-trip a cada mudança (Story, critérios de aceite 11/12).
export class VendedorHierarquiaHelper {

  static getAncestrais(idVendedor: number, flat: VendedorHierarquiaStruct[]): VendedorHierarquiaStruct[] {
    const porId = new Map(flat.map(v => [v.idVendedor, v]));
    const ancestrais: VendedorHierarquiaStruct[] = [];
    const visitados = new Set<number>([idVendedor]);

    let atualId = porId.get(idVendedor)?.idVendedorResponsavel ?? null;
    while (atualId != null && porId.has(atualId)) {
      if (visitados.has(atualId)) break;
      visitados.add(atualId);
      const responsavel = porId.get(atualId)!;
      ancestrais.push(responsavel);
      atualId = responsavel.idVendedorResponsavel;
    }

    return ancestrais;
  }

  static getDescendentes(idVendedor: number, flat: VendedorHierarquiaStruct[]): Set<number> {
    const filhosPorResponsavel = new Map<number, number[]>();
    for (const v of flat) {
      if (v.idVendedorResponsavel == null) continue;
      const lista = filhosPorResponsavel.get(v.idVendedorResponsavel) ?? [];
      lista.push(v.idVendedor);
      filhosPorResponsavel.set(v.idVendedorResponsavel, lista);
    }

    const descendentes = new Set<number>();
    const pilha: number[] = [idVendedor];
    while (pilha.length > 0) {
      const atual = pilha.pop()!;
      const filhos = filhosPorResponsavel.get(atual);
      if (!filhos) continue;
      for (const filhoId of filhos) {
        if (!descendentes.has(filhoId)) {
          descendentes.add(filhoId);
          pilha.push(filhoId);
        }
      }
    }

    return descendentes;
  }

  static getQtdSubordinadosDiretos(idVendedor: number, flat: VendedorHierarquiaStruct[]): number {
    return flat.filter(v => v.idVendedorResponsavel === idVendedor).length;
  }

  // Verdadeiro quando definir candidatoResponsavelId como responsável de idVendedor criaria ciclo.
  static criaCiclo(idVendedor: number, candidatoResponsavelId: number | null | undefined, flat: VendedorHierarquiaStruct[]): boolean {
    if (candidatoResponsavelId == null) return false;
    if (candidatoResponsavelId === idVendedor) return true;
    return this.getDescendentes(idVendedor, flat).has(candidatoResponsavelId);
  }
}
